const handovertemplate = {
	name: 'Handover protocol templates',
	fields: {
		name: 'Name',
		rooms_count: 'Rooms',
	},
}

export default handovertemplate
